import request from 'superagent';

export const checkJsonResult = (r) => {
  if (r.ok) {
    return r.json();
  }
  const err = new Error(`${r.status}: ${r.statusText}`);
  err.raw = r;
  err.status = r.status;
  err.statusText = r.statusText;
  try {
    err.json = JSON.parse(r.response.text);
  } catch (ex) {
    // nothing to do
  }
  throw err;
};
export const basePostOption = {
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};
export const makeFetchJsonWithOption = option => url => body => fetch(
  url,
  {
    ...option,
    body: body && JSON.stringify(body),
  },
).then(checkJsonResult);

export const makeAjaxJsonWithOption = option => url => body => request(option.method, url)
  .set(option.headers)
  .send(body)
  .then((r) => {
    // make superagent Response compatible with fetch Response
    r.json = () => r.body;
    return r;
  })
  .then(checkJsonResult)
  .catch(checkJsonResult);

export const makeFetchJson = makeFetchJsonWithOption(basePostOption);

export const makeAjaxJson = makeAjaxJsonWithOption(basePostOption);



// WEBPACK FOOTER //
// ./src/api/util.js